import { StyleOptions } from 'botframework-webchat';
import chatBotAvatarIcon from '/chatBotAvatarIcon.svg';
import userAvatarImage from '/userAvatarImage.svg';

export const WebChatStyleOptions: StyleOptions = {
  backgroundColor: '#FAFAFA',
  primaryFont: 'Roboto, sans-serif',
  fontSizeSmall: '68.75%' /*11px*/,
  paddingRegular: 8,

  hideUploadButton: true,
  botAvatarImage: chatBotAvatarIcon,
  botAvatarInitials: '',
  botAvatarBackgroundColor: '#FDFBF4',

  /* common for both avatars */
  avatarBorderRadius: '50%',
  avatarSize: 28,

  /* user avatar */
  userAvatarImage: userAvatarImage,
  userAvatarInitials: '',
  userAvatarBackgroundColor: '#FDFBF4',

  bubbleTextColor: '#353535',
  bubbleBackground: '#FAFAFA',
  bubbleBorderColor: '#CFCFCF',
  bubbleBorderRadius: 8,
  bubbleBorderStyle: 'solid',
  bubbleBorderWidth: 1,
  bubbleFromUserBackground: '#FAFAFA',
  bubbleFromUserBorderColor: '#CFCFCF',
  bubbleFromUserBorderRadius: 8,
  bubbleFromUserBorderStyle: 'solid',
  bubbleFromUserBorderWidth: 1,
  bubbleMinHeight: 20,

  /* timestamp */
  timestampColor: '#707070',

  /* send button */
  sendBoxButtonColor: '#5D4037' /* Icon color */,
  sendBoxButtonShadeColor: '#F7F7F7',
  sendBoxButtonShadeBorderRadius: 4,

  /* sendbox */
  sendBoxTextWrap: true,
  sendBoxButtonAlignment: 'top',
  sendBoxHeight: 58,
  sendBoxMaxHeight: 300,
  sendBoxTextColor: '#353535',
  transcriptActivityVisualKeyboardIndicatorStyle: '',

  /* suggested buttons */
  suggestedActionLayout: 'flow',
  suggestedActionBorderRadius: 4,
  suggestedActionBackgroundColor: '#F5F5F5',
  suggestedActionBorderColor: '#DFDFDF',
  suggestedActionBorderStyle: 'solid',
  suggestedActionBorderWidth: 1,
  suggestedActionTextColor: '#353535',
  suggestedActionsVisualKeyboardIndicatorWidth: 0,

  suggestedActionBackgroundColorOnHover: '#EBEBEB',
  suggestedActionBorderColorOnHover: '#999',
  suggestedActionBorderStyleOnHover: 'solid',
  suggestedActionBorderWidthOnHover: 1,
  suggestedActionTextColorOnHover: '#5E5E5E',

  typingAnimationBackgroundImage: `url('/spinner.svg')`,
  typingAnimationHeight: 24,
  typingAnimationWidth: 24,
};
